import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';
import { TrackableList, CreateTrackableList } from 'types/trackables';

import { useAPI } from 'hooks/api/useAPI';

export function useCreateTrackableList({
  onSettled,
  ...options
}: UseMutationOptions<TrackableList, APIError, CreateTrackableList> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async (data: CreateTrackableList) => {
      const response = await client.post(`/apps/${applicationID}/trackables`, data);
      return response.data;
    },
    {
      ...options,
      onSettled: (...args) => {
        onSettled?.(...args);

        // Invalidate trackable lists queries
        queryClient.invalidateQueries(['trackable-lists']);
      },
    }
  );
}